export const UserRole = {
  ADMIN: 'ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  COLLABORATOR: 'COLLABORATOR',
};

export const isAdmin = (user) => user?.role === UserRole.ADMIN;
export const isCompanyAdmin = (user) => user?.role === UserRole.COMPANY_ADMIN;
export const isCollaborator = (user) => user?.role === UserRole.COLLABORATOR;
